const baseSpace = 2;
const modulePadding = baseSpace / 2;

export const actionColor = '#0761cc';
export const green = '#69bc4c';
export const red = '#ED3535';
export const blue = '#0761cc';

export default {
  baseSpace: `${baseSpace}em`,
  modulePadding: `${modulePadding}em`,
  actionColor,
  green,
  orange: '#F78E1F',
  bodyBackground: '#fbfbfb',
};
